<div class="block-style">
   <div *ngFor="let call of callHistory" fxLayout="row">
      <div fxFlex="none" class="peer" *ngIf="call?.peerId | isAnonymous">
         {{ 'common.calling.unknown_number' | translate }}
      </div>
      <div fxFlex="none" class="peer" *ngIf="!(call?.peerId | isAnonymous)">
         {{ call.peerName }} (
         <span
            (click)="isCall(call.conversationType) && callHistroy(call?.peerId)"
            [ngClass]="{
               callable: isCall(call.conversationType)
            }"
         >
            {{ call.peerId }}
         </span>
         )
      </div>
      <samweb-call-time
         [timestamp]="call.timestamp"
         [conversationStatusTypeAsSamwinValue]="call.state"
         [showPrimaryFullDateFormat]="true"
         class="sam-ellipsis-on-overflow"
         fxFlex
      >
      </samweb-call-time>
   </div>
</div>
